import { render } from "./MediaUploadButton.vue?vue&type=template&id=1a4bce93"
import script from "./MediaUploadButton.vue?vue&type=script&lang=js"
export * from "./MediaUploadButton.vue?vue&type=script&lang=js"
script.render = render

export default script